export const isVoucherExpired = (record) =>
  record?.end_date && new Date(record.end_date).getTime() < new Date().getTime()
